const CONSENT_KEY = 'gundo-vida-cookie-consent';
const HEALTH_CONSENT_KEY = 'gundo-vida-health-consent';

export interface CookieConsent {
  essential: true; // always true
  analytics: boolean;
  functional: boolean;
  timestamp: string;
}

export interface HealthDataConsent {
  nutritionProfile: boolean;
  healthTests: boolean;
  emailCommunications: boolean;
  pushNotifications: boolean;
  timestamp: string;
}

// ── Cookie Consent ──────────────────────────────────────────────────────

export function getCookieConsent(): CookieConsent | null {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function setCookieConsent(consent: Omit<CookieConsent, 'essential' | 'timestamp'>) {
  const full: CookieConsent = {
    essential: true,
    ...consent,
    timestamp: new Date().toISOString(),
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(full));
  return full;
}

export function hasAnalyticsConsent(): boolean {
  return getCookieConsent()?.analytics ?? false;
}

export function applyConsentToGtag(c: CookieConsent): void {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('consent', 'update', {
    analytics_storage: c.analytics ? 'granted' : 'denied',
    functionality_storage: c.functional ? 'granted' : 'denied',
    personalization_storage: c.functional ? 'granted' : 'denied',
  });
}

declare global {
  interface Window {
    gtag?: (command: string, target: string, config?: Record<string, unknown>) => void;
  }
}

// ── Health Data Consent ─────────────────────────────────────────────────

export function getHealthConsent(): HealthDataConsent | null {
  try {
    const stored = localStorage.getItem(HEALTH_CONSENT_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function setHealthConsent(consent: Omit<HealthDataConsent, 'timestamp'>) {
  const full: HealthDataConsent = {
    ...consent,
    timestamp: new Date().toISOString(),
  };
  localStorage.setItem(HEALTH_CONSENT_KEY, JSON.stringify(full));
  return full;
}
